const removeCookie = (key: string) => {
  document.cookie = `${key}=; max-age=0`;
};
const removeCookieForDomain = (key: string, domain: string) => {
  document.cookie = `${key}=; max-age=0; path=/; domain=${domain}`;
};
const cookieAnalize = (allCookie: string) => {
  return {
    searchCookies: (startString: string) => {
      return allCookie.split('; ').filter((row) => row.startsWith(startString));
    },
  };
};
// Cookieのdomain属性を変更しても、変更前にセットされたCookieはブラウザに残り続け
// 新ドメインのCookieと名前が重複してログイン状態が不安定になるため、
// 起動時に旧ドメインのCookieだけを明示的に削除する
const removeCookiesOnLegacyDomain = (prefix: string, legacyDomain: string) => {
  const domains = Array.from(new Set([legacyDomain, `.${legacyDomain}`]));
  cookieAnalize(document.cookie)
    .searchCookies(prefix)
    .forEach((cookie) => {
      const key = cookie.split('=')[0];
      domains.forEach((domain) => removeCookieForDomain(key, domain));
    });
};
export const cookieUtils = {
  removeCookie,
  removeCookieForDomain,
  cookieAnalize,
  removeCookiesOnLegacyDomain,
};
